import AvailabilityList from "./AvailabilityList";
import { Container } from "@mui/material";
import Banner from "components/templates/Banner";
import AddAvailability from "pages/AddAvailability";
import BlockComponent from "components/organisms/BlockComponent/BlockComponent";

export default function Availability() {
  return (
    <div>
      <Container maxWidth="lg">
        <Banner heading="Availability"></Banner>
        <BlockComponent permission={"availability:edit"}>
          <AddAvailability />
        </BlockComponent>
        <AvailabilityList />
      </Container>
    </div>
  );
}
